import axios from 'axios'

export { getSurvey, submitSurvey }

function submitSurvey (data) {
  let key = localStorage.getItem('sessionKey')
  const header = {
    Authorization: `Bearer ${key}`
  }
  return axios.post(`${process.env.VUE_APP_Q_OPD_API}/survey/response/save?sessionKey=${key}`, data)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err)
      return Promise.reject(err.response)
    })
}

function getSurvey () {
  let key = localStorage.getItem('sessionKey')
  return axios.get(`${process.env.VUE_APP_Q_OPD_API}/survey/group/list?sessionKey=${key}`)
    .then((res) => res.data.surveys)
    .catch((err) => {
      console.log(err)
      return Promise.reject(err.response)
    })
}
